import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import './firstModal.css';
import Labels from '../../components/translations/translation.json'

 function FirstModal(props) {
  const [open] = useState(true);
  const [close] = useState(true);
  const [scroll, setScroll] = React.useState('paper');
  const languageCode = props.langCode;

  const handleClickOpen = (scrollType) => () => {
    // setOpen(true);
    setScroll(scrollType);
  };

   const handleClose = () => {
        props.callbackClose();
    }

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  const initialPopupText = () => {
  
    if (languageCode) {
      switch (languageCode) {
        case 'NL': // Dutch (Nederlands)
          return 'Goeiedag, we bedanken u voor het scannen van deze QR code. Dit wordt de nieuwe NMBS toepassing die elke treinreiziger zal toelaten om technische problemen in het station te melden. De toepassing is momenteel in testfase en zal in de loop van September 2023 beschikbaar zijn. Hartelijk dank voor uw medewerking aan de verbetering van het comfort van onze stations.';
    
        case 'FR': // French (Français)
          return 'Bonjour, nous vous remercions d’avoir scanné le QR code. Voici la nouvelle application de la SNCB qui permettra à tout voyageur de déclarer un incident technique détecté dans les gares. Nous sommes actuellement en phase de test de sorte que l’application vous sera accessible en septembre 2023. Un tout grand merci pour votre contribution à l’amélioration du confort de nos gares.';
    
        case 'DE': // German (Deutsch)
          return 'Hallo, vielen Dank für das Scannen des QR-Codes. Hier ist die neue SNCB-Applikation, die es jedem Fahrgast ermöglicht, einen in Bahnhöfen festgestellten technischen Zwischenfall zu melden. Die Applikation befindet sich zurzeit in der Testphase und wird Ihnen im September 2023 zur Verfügung stehen. Vielen Dank für Ihren Beitrag zur Verbesserung des Komforts in unseren Bahnhöfen.';
    
        case 'EN': // English
          return 'Hello, thank you for scanning the QR code. Here is the new SNCB application which will allow travellers to report technical incidents detected in a station. The application is in test phase and will be available in September 2023. Thank you very much for your contribution to improving the comfort in our stations.';
    
        default:
          return `Goeiedag, we bedanken u voor het scannen van deze QR code. Dit wordt de nieuwe NMBS toepassing die elke treinreiziger zal toelaten om technische problemen in het station te melden. De toepassing is momenteel in testfase en zal in de loop van September 2023 beschikbaar zijn. Hartelijk dank voor uw medewerking aan de verbetering van het comfort van onze stations.\n\nBonjour, nous vous remercions d’avoir scanné le QR code. Voici la nouvelle application de la SNCB qui permettra à tout voyageur de déclarer un incident technique détecté dans les gares. Nous sommes actuellement en phase de test de sorte que l’application vous sera accessible en septembre 2023. Un tout grand merci pour votre contribution à l’amélioration du confort de nos gares.\n\nHallo, vielen Dank für das Scannen des QR-Codes. Hier ist die neue SNCB-Applikation, die es jedem Fahrgast ermöglicht, einen in Bahnhöfen festgestellten technischen Zwischenfall zu melden. Die Applikation befindet sich zurzeit in der Testphase und wird Ihnen im September 2023 zur Verfügung stehen. Vielen Dank für Ihren Beitrag zur Verbesserung des Komforts in unseren Bahnhöfen.\n\nHello, thank you for scanning the QR code. Here is the new SNCB application which will allow travellers to report technical incidents detected in a station. The application is in test phase and will be available in September 2023. Thank you very much for your contribution to improving the comfort in our stations.`;
      }
    }
  };
  

  const cookiepopupText = () => {
    const languageCode = props.langCode;
  
    if (languageCode) {
      switch (languageCode) {
        case 'NL': // Dutch (Nederlands)
          return 'Wij gebruiken enkel strikt noodzakelijke cookies. Deze cookies zijn noodzakelijk om de applicatie te laten functioneren en kunnen niet worden uitgeschakeld in onze systemen. Ze worden meestal alleen ingesteld naar aanleiding van bepaalde acties van een gebruiker zoals het indienen van een verzoek of het instellen van uw privacy voorkeuren of het inloggen en/of het invullen van formulieren. U kunt de instellingen in uw browser wijzigen zodat deze cookies geblokkeerd worden of zodat u een waarschuwing krijgt. Indien u dit doet, kunnen sommige onderdelen van de applicatie niet meer werken zoals voorzien.';
    
        case 'FR': // French (Français)
          return 'Nous n\'utilisons que des cookies strictement nécessaires. Ces cookies sont nécessaires au fonctionnement de l\'application et ne peuvent donc pas être désactivés dans nos systèmes. Ils sont généralement définis en réponse à certaines actions de l\'utilisateur, telles que la soumission d\'une demande ou la définition de ses préférences de confidentialité ou la connexion et/ou le remplissage de formulaires. Vous pouvez modifier les paramètres de votre navigateur afin que ces cookies soient bloqués ou que vous receviez un avertissement. Par conséquent, certaines parties de l\'application peuvent ne plus fonctionner comme prévu.';
    
        case 'DE': // German (Deutsch)
          return 'Wir verwenden nur unbedingt erforderliche Cookies. Diese Cookies sind für das Funktionieren der Anwendung notwendig und können daher in unseren Systemen nicht deaktiviert werden. Sie werden in der Regel als Reaktion auf bestimmte Aktionen des Nutzers gesetzt, wie z. B. die Einreichung einer Anfrage oder die Festlegung von Datenschutzeinstellungen oder die Anmeldung und/oder das Ausfüllen von Formularen. Sie können die Einstellungen Ihres Browsers so ändern, dass diese Cookies blockiert werden oder dass Sie eine Warnung erhalten. Dies kann dazu führen, dass einige Teile der Anwendung nicht wie vorgesehen funktionieren.';
    
        case 'EN': // English
          return 'We use only strictly necessary cookies. These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms. You can set your browser to block or alert you about these cookies, but some parts of the site may not work anymore.';
          
        default:
            return `Wij gebruiken enkel strikt noodzakelijke cookies. Deze cookies zijn noodzakelijk om de applicatie te laten functioneren en kunnen niet worden uitgeschakeld in onze systemen. Ze worden meestal alleen ingesteld naar aanleiding van bepaalde acties van een gebruiker zoals het indienen van een verzoek of het instellen van uw privacy voorkeuren of het inloggen en/of het invullen van formulieren. U kunt uw browser instellen wijzigen zodat deze cookies geblokkeerd worden of u een waarschuwing krijgt. Hierdoor kunnen sommige onderdelen van de applicatie niet meer werken zoals voorzien.<br><br>
            Nous n'utilisons que des cookies strictement nécessaires. Ces cookies sont nécessaires au fonctionnement de l'application et ne peuvent donc pas être désactivés dans nos systèmes. Ils sont généralement définis en réponse à certaines actions de l'utilisateur, telles que la soumission d'une demande ou la définition de ses préférences de confidentialité ou la connexion et/ou le remplissage de formulaires. Vous pouvez modifier les paramètres de votre navigateur afin que ces cookies soient bloqués ou que vous receviez un avertissement. Par conséquent, certaines parties de l'application peuvent ne plus fonctionner comme prévu.<br><br>
            Wir verwenden nur unbedingt erforderliche Cookies. Diese Cookies sind für das Funktionieren der Anwendung notwendig und können daher in unseren Systemen nicht deaktiviert werden. Sie werden in der Regel als Reaktion auf bestimmte Aktionen des Nutzers gesetzt, wie z. B. die Einreichung einer Anfrage oder die Festlegung von Datenschutzeinstellungen oder die Anmeldung und/oder das Ausfüllen von Formularen. Sie können die Einstellungen Ihres Browsers so ändern, dass diese Cookies blockiert werden oder dass Sie eine Warnung erhalten. Dies kann dazu führen, dass einige Teile der Anwendung nicht wie vorgesehen funktionieren.<br><br>
            We use only strictly necessary cookies. These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms. You can set your browser to block or alert you about these cookies, but some parts of the site may not work anymore.`;
    
      }
    }
  };
    
  
  return (
    <div>
      <Dialog
        open={open}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title" className="info-title">
        {props.isInitialPopup ?
          (<div> <p className='info-title-text'>Inlichtingen – Information</p> </div>) : (<div> <p className='info-title-text'>{Labels[languageCode].INFORMATION_MODAL}</p> </div>) }
        { close ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: '#000',
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}  
        </DialogTitle>
        <DialogContent dividers={scroll === 'paper'}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
          {props.isInitialPopup ? (<div>
          <p className="firstModalpara">{initialPopupText()}</p>
          </div>) : (<div>
          <div
      className="firstModalpara"
      dangerouslySetInnerHTML={{ __html: cookiepopupText() }}
    ></div>

          </div>)}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className='btn-info-ok' variant="contained" onClick={handleClose}>Ok</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

FirstModal.propTypes = {
  langCode: PropTypes.string,
  callbackClose: PropTypes.func,
  isInitialPopup: PropTypes.bool,
};

export default FirstModal;